import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../GramLayouts/index";

import GetPageData from "../../hooks/GetPageData";
import LoadingComponet from "../../components/Loading/LoadingComponet";
import { useParams } from "react-router-dom";
// import pagedata from "../../gramdata/developmentWork";

// import pagedata from "../../gramdata/egramsevao";

import TitleContainer from "../../Layouts/Achievements/TitleContainer";
import LayoutContainer from "../../components/LayoutsContainer";
import { useSelector } from "react-redux";
import Axios from "axios";
import { RootUrl } from "../../redux/types";
import { Card, CardContent, Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    minHeight: "40vh",
    [theme.breakpoints.down("md")]: {
      minHeight: "60vh",
      paddingTop: theme.spacing(2),
    },
  },
  titleContainer: {
    paddingTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(2),
    },
  },
  noDataCard: {
    marginTop: theme.spacing(2),
  },
}));

const InfoPage = () => {
  const noDataCard = () => {
    return (
      <Card className={classes.noDataCard}>
        <CardContent>
          <Typography>{data?.noInfoTitle || "Data Not Found"}</Typography>
        </CardContent>
      </Card>
    );
  };

  const params = useParams();

  const classes = useStyles();
  const gramId = useSelector((state) => state.util.currentGramId);

  const language = useSelector((state) => state.util.language);

  const [ready, setReady] = React.useState(false);
  const [data, setData] = React.useState(false);
  const [error, setError] = React.useState(false);

  const getData = async () => {
    await Axios.get(
      `${RootUrl}/gramInfo/${params.type}/${gramId}/${language}`,
      {
        // body: JSON.stringify(url),
        headers: {
          "Content-Type": "application/json",

          // "Access-Control-Allow-Origin": "*",
        },
      }
    )

      .then((res) => {
        console.log("response", res.data.data);
        setData(res?.data.data);
        setReady(true);
      })
      .catch((err) => setError(err));
  };
  React.useEffect(() => {
    getData();
  }, [params.type]);
  return ready && data ? (
    <div className={classes.root}>
      <LayoutContainer>
        {data?.title && (
          <div className={classes.titleContainer}>
            <TitleContainer title={data.title} />
          </div>
        )}

        {data?.data
          ? data?.data?.map((data, index) => {
              const Layout = layouts[data?.layout];
              return <Layout key={index} data={data} />;
            })
          : noDataCard()}
      </LayoutContainer>
    </div>
  ) : (
    <LoadingComponet />
  );
  // return ready && data ? (
  //   <div className={classes.root}>
  //     {data?.data?.map((data, index) => {
  //       const Layout = layouts[data?.layout];
  //       return <Layout key={index} data={data} />;
  //     })}
  //   </div>
  // ) : (
  //   <div>
  //     <LoadingComponet />
  //   </div>
  // );
};
export default InfoPage;
